import React from "react";
import Response from "../../components/Response/Response";

export default function ResponsePage() {
  return (
    <div>
      <Response></Response>
    </div>
  );
}
